export default __webpack_public_path__ + "static/media/horizon_client.6a600c3f.png";